import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
} from "../../../../../utils/commonQueryTypes";

export enum MstCustomerOrderField {
  CREATED_AT = "CREATED_AT",
  NAME = "NAME",
  PLACE = "PLACE",
}

export interface GetCustomersVar extends commonPaginationTypes {
  name: string;
  orderBy: {
    direction: OrderDirection;
    field: MstCustomerOrderField;
  };
}

export interface MstCustomer {
  id: number;
  code: string;
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  isActive: string;
  panNo: string;
  gstNo: string;
  custTimeZone: string;
}

export interface MstCustomerEdge {
  node: MstCustomer;
  cursor: string;
}

interface GetCustomersData {
  edges: MstCustomerEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetCustomersResult {
  GetCustomers: GetCustomersData;
}

//Mutations
interface CreateMstCustomerInput {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  isActive: string;
  panNo: string;
  gstNo: string;
}

export interface AddCustomerVar extends commonMutationTypes {
  input: CreateMstCustomerInput;
}

export interface AddCustomerResult {
  AddCustomer: {
    id: string;
  };
}

export interface UpdateCustomerVar extends commonMutationTypes {
  id: number;
  input: CreateMstCustomerInput;
}

export interface UpdateCustomerResult {
  UpdateCustomer: boolean;
}


